"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styleUtilities_1 = require("../../util/styleUtilities");
var divider = "1px solid ".concat((0, styleUtilities_1.withOpacity)('#2a2b38', 0.08));
exports.default = divider;
